export default [
  {
    title: 'ID',
    key: 'id',
    width: 72,
    fixed: true
  },
  {
    title: '素材名称',
    key: 'imageName',
    width: 240,
    fixed: true
  },
  {
    title: '上传时间',
    key: 'uploadTime',
    width: 140,
    sortable: 'custom'
  },
  {
    title: '点击率',
    key: 'clickRate',
    width: 72,
    sortable: 'custom'
  },
  {
    title: '实际消耗',
    key: 'amount',
    width: 82,
    sortable: 'custom'
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    width: 82,
    sortable: 'custom'
  },
  {
    title: '付费成本',
    key: 'payCost',
    width: 82,
    sortable: 'custom'
  },
  {
    title: '转化率',
    key: 'activeRate',
    width: 72,
    sortable: 'custom'
  },
  {
    title: '首日创角付费率',
    key: 'payRoleUserRate',
    width: 120,
    sortable: 'custom'
  },
  {
    title: '首日ROI',
    key: 'oneDayRoi',
    width: 82,
    sortable: 'custom'
  },
  {
    title: '3日ROI',
    key: 'threeDayRoi',
    width: 82,
    sortable: 'custom'
  },
  {
    title: '7日ROI',
    key: 'sevenDayRoi',
    width: 82,
    sortable: 'custom'
  }
]
